import { Grid, makeStyles } from '@material-ui/core'
import ProfilePicture from 'components/common/ProfilePicture'
import React, { useMemo } from 'react'

import HoveredActions from 'components/common/HoveredActions'
import { Check2 } from 'components/common/icons'
import OpenInNewTabIcon from 'components/common/icons/OpenInNewTabIcon'
import NeedsAttentionReason from 'components/common/NeedsAttentionReason'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import Tooltip from 'components/common/Tooltip'
import PatientStatus from 'components/Patients/PatientStatus'
import { ROUTES } from 'consts'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { getEnvironmentHostname } from 'utils/awsUtils'

const useStyles = makeStyles(() => ({
  patientItem: {
    position: 'relative',
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    borderBottom: '1px solid #E9E9E9'
  },
  avatar: {
    width: '12%',
    maxWidth: 80
  },
  patientNameStatusContainer: {
    width: '21%',
    display: 'flex',
    flexDirection: 'column'
  },
  needsAttentionReasonContainer: {
    width: '22%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  noteContainer: {
    width: '45%',
    paddingRight: 20
  },
  note: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  time: {
    color: '#95A4C1',
    position: 'absolute',
    bottom: 7,
    right: 15,
    fontSize: 11
  }
}))

const NeedsAttentionPatientItem = ({ patientId, patientName, profilePicture, status, needsAttentionData }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const actions = useMemo(
    () =>
      [
        {
          key: 'openPatient',
          icon: <OpenInNewTabIcon />,
          tooltip: t('pages.copilotControl.widgets.needsAttention.actions.openPatient'),
          onClick: () => window.open(`${getEnvironmentHostname()}${ROUTES.PATIENTS}/${patientId}`, '_blank'),
          condition: () => true
        },
        {
          key: 'resolve',
          icon: <Check2 />,
          tooltip: t('pages.copilotControl.widgets.needsAttention.actions.resolve'),
          disabled: true,
          onClick: () => console.log('resolve'),
          condition: () => true
        }
      ].filter(action => action.condition()),
    [patientId, t]
  )

  const [isHovered, setIsHovered] = React.useState(false)

  return (
    <Grid
      container
      item
      className={classes.patientItem}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Grid item className={classes.avatar}>
        <ProfilePicture name="Tom Baum" photo={profilePicture} />
      </Grid>
      <Grid item className={classes.patientNameStatusContainer}>
        <Grid item>
          <DazzedParagraph14 className={classes.patientNameText}>{patientName}</DazzedParagraph14>
        </Grid>
        <Grid item>
          <PatientStatus status={status} />
        </Grid>
      </Grid>
      <Grid item className={classes.needsAttentionReasonContainer}>
        <NeedsAttentionReason reason={needsAttentionData.reason} shortened />
      </Grid>
      <Grid item className={classes.noteContainer}>
        <Tooltip value={needsAttentionData.note} placement="top" arrow variant="light">
          <div className={classes.note}>{needsAttentionData.note}</div>
        </Tooltip>
      </Grid>
      <div className={classes.time}>{moment(needsAttentionData.createdAt).fromNow()}</div>
      <HoveredActions actions={actions} isOpen={isHovered} placement="top" />
    </Grid>
  )
}

export default NeedsAttentionPatientItem
